import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: "15px",
  },
  areaTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#1f2937",
    marginBottom: "5px",
  },

  secondaryTitles: {
    fontSize: "15px",
    fontWeight: "bold",
    color: "#1f2937",
  },

  paragapthText: {
    fontSize: "11px",
    color: "black",
  },

  subAreaTitle: {
    fontSize: "13px",
    fontWeight: "bold",
    color: "#4b5563",
  },
  contentSection: {
    margin: "10px",
    flexDirection: "column",
    maxHeight: "650px",
  },
  textarea: {
    fontSize: "12px",
    flexWrap: "wrap",
  },
  headerTitleSection: {
    paddingTop: "15px",
    flexDirection: "column",
    width: "100%",
  },

  headerImageSection: {
    flexDirection: "column",
    width: "100%",
  },

  headerContentSection: {
    flexDirection: "column",
    width: "100%",
  },

  row: {
    flexDirection: "row",
  },

  col: {
    flexDirection: "column",
  },

  headerContainerTextFullColumn: {
    fontSize: "12px",
  },


  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#111827",
    textAlign: "right",
    paddingBottom: "10px",
  },

  areaSection: {
    paddingTop: "20px",
    flexDirection: "column",
    width: "100%",
  },

  subAreaSection: {
    padding: "10px",
    flexDirection: "column",
    width: "100%",
  },

  table: {
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: '#e5e7eb',
    borderRadius: 4,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#e5e7eb',
  },
  tableColHeader: {
    width: '25%',
    borderBottomWidth: 1,
    borderColor: '#e5e7eb',
    backgroundColor: '#f9fafb',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableCol: {
    width: '25%',
    padding: "8px 5px",
    borderRightWidth: 1,
    borderColor: '#e5e7eb',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  tableCellHeader: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#374151',
    padding: 8,
  },
  tableCell: {
    margin: 'auto',
    marginVertical: 5,
    fontSize: 10,
    color: '#4b5563',
    textAlign: 'center',
  },
  star: {
    width: 12,    // Adjust the width as needed
    height: 12,   // Adjust the height as needed
    margin: 1 // Gives some space between stars
  },

  starsContainer: {
    flexDirection: 'row',  // To display stars horizontally
    alignItems: 'center',  // Center stars vertically within the container
    justifyContent: 'center' // Starts the stars from the left side of the container
  },

  // NDIS Questions Styles
  section: {
    marginTop: 10,
    marginBottom: 10,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 10,
    paddingBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  questionContainer: {
    marginBottom: 15,
    paddingLeft: 10,
  },
  questionText: {
    fontSize: 12,
    marginBottom: 5,
  },
  questionLabel: {
    fontWeight: 'bold',
    color: 'black',
  },
  answerText: {
    fontSize: 12,
    marginTop: 5,
  },
  answerLabel: {
    fontWeight: 'bold',
    color: 'black',
  },
  answerYes: {
    color: 'green',
    fontWeight: 'bold',
  },
  answerNo: {
    color: 'red',
    fontWeight: 'bold',
  },
  incidentDetailsContainer: {
    marginTop: 10,
    paddingLeft: 10,
  },
  incidentDetailsLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'black',
    marginBottom: 5,
  },
  incidentDetailsText: {
    fontSize: 11,
    color: 'black',
    padding: 8,
    backgroundColor: '#f8f9fa',
    borderWidth: 1,
    borderColor: '#dee2e6',
    borderRadius: 4,
  }

});
